import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

export const BackButton = () => {
  const navigate = useNavigate();
  const onClickBackBtn = () => {
    navigate(-1);
  };

  return (
    <Button
      variant="contained"
      color="primary"
      onClick={() => onClickBackBtn()}
    >
      戻る
    </Button>
  );
};
